<div *ngIf="sponsor" class="sponsor">
  <app-img-format
    class="sponsor-img sponsor-{{ sponsor.sponsorImageOrientation }}"
    *ngIf="sponsor.sponsorImageUrl"
    [src]="sponsor.sponsorImageUrl"
    [alt]="sponsor?.name"
    [aspectRatio]="'16:9'"
    [disableLazyLoad]="true"></app-img-format>
  <span *ngIf="sponsor.byText" class="sponsor-details">
    {{ sponsor.byText | uppercase }}
  </span>
</div>
